/**
 * Обёртка секции настроек: заголовок + Card
 *
 * Паттерн: мелкий серый заголовок (text-sm) + Card с контентом
 * По умолчанию children оборачиваются в Card.
 * noCard — режим без Card (children рендерятся напрямую).
 */

import { type ReactNode } from 'react';
import { Card } from '@/components/ui/card';

/** Стандартные внутренние отступы Card в настройках */
const DEFAULT_CARD_CLASS = 'px-4 py-4 gap-4';

interface SettingsSectionProps {
  /** Текст заголовка секции */
  title: string;
  /** Содержимое секции (внутри Card или напрямую) */
  children: ReactNode;
  /** Классы для Card (по умолчанию "px-4 py-4 gap-4") */
  cardClassName?: string;
  /** Не оборачивать children в Card */
  noCard?: boolean;
  /** Дополнительные классы для обёртки section */
  className?: string;
}

export function SettingsSection({
  title,
  children,
  cardClassName = DEFAULT_CARD_CLASS,
  noCard = false,
  className,
}: SettingsSectionProps): JSX.Element {
  return (
    <section className={className}>
      <h2 className="text-sm font-normal text-muted-foreground mb-2 px-1">
        {title}
      </h2>
      {noCard ? children : <Card className={cardClassName}>{children}</Card>}
    </section>
  );
}